exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_wks-ext.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_wks-ext.js
// module chunks = 0